import { useMutation } from '@apollo/client';
import { Modal } from 'antd';
import React from 'react';
import { DELETE_TRUCK } from '../graphql/Mutation';

const DeleteModal = ({
  showModal,
  setShowModal,
  deleteData,
  refetch,
  setDeleteData
}) => {
  const [deleteTruck, { loading }] = useMutation(DELETE_TRUCK, {
    onError() {}
  });

  const handleCancel = () => {
    setShowModal(false);
    setDeleteData();
  };

  const handleOk = async () => {
    const response = await deleteTruck({
      variables: {
        where: {
          id: deleteData?.id
        }
      }
    });
    if (response) {
      setShowModal(false);
      refetch();
    }
  };

  return (
    <Modal
      visible={showModal}
      onCancel={handleCancel}
      okText="Yes, Delete"
      cancelText="No, Cancel"
      centered
      title="Delete Truck"
      okButtonProps={{ danger: true }}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <h3>Are you sure you want to delete truck {deleteData?.name} ? </h3>
    </Modal>
  );
};

export default DeleteModal;
